import { updateSharingLinkFromSharingDialog } from '../actions/internalActions';
import getSharingLink from '../selectors/getSharingLink';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { mutator } from 'satcheljs';

mutator(updateSharingLinkFromSharingDialog, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLink(actionMessage.linkId);

    sharingLink.sharingInfo.blocksDownload = actionMessage.sharingDialogResponse.blocksDownload;
});
